import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from "react-i18next";
import { i18en } from "./lan/i18en";
import { i18fr } from "./lan/i18fr";
import moment from "moment";
const resources = {
  en: {
    translation: { ...i18en }
  },
  fr: {
    translation: { ...i18fr }
  }
};

const getLocalization = () => {
  const localisation = document.querySelector('meta[name="localization"]')?.getAttribute?.('content')
  moment.updateLocale(localisation || "fr", { week: { dow: 1 } })
  return localisation || "fr"
}

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    interpolation: {
      escapeValue: false
    },
    // fallbackLng: 'fr',
    // lng: 'fr',
    resources,
    lng: getLocalization(),
  });

export default i18n;